/**
 * Styles CSS optimisés pour l'impression des fiches adhérent
 */
export const PRINT_STYLES = `
    body { 
        font-family: Arial, sans-serif; 
        margin: 12px; 
        font-size: 10px; 
        color: #000; 
        line-height: 1.2;
    }
    
    h1 { 
        text-align: center; 
        border-bottom: 2px solid #000; 
        padding-bottom: 6px; 
        margin-bottom: 12px; 
        font-size: 15px;
    }
    
    .section { 
        border: 1px solid #ccc; 
        margin-bottom: 8px; 
        page-break-inside: avoid; 
        background: white;
    }
    
    .section-header { 
        background: #f0f0f0; 
        padding: 5px 8px; 
        border-bottom: 1px solid #ccc; 
        font-weight: bold; 
        font-size: 11px;
    }
    
    .section-content { 
        padding: 6px 8px; 
    }
    
    .info-row { 
        margin-bottom: 2px; 
        display: flex;
        align-items: baseline;
    }
    
    .label { 
        font-weight: bold; 
        color: #333; 
        font-size: 9px; 
        min-width: 100px;
        margin-right: 6px;
    }
    
    .value { 
        color: #000; 
        font-size: 10px; 
        flex: 1;
    }
    
    table { 
        width: 100%; 
        border-collapse: collapse; 
        margin: 5px 0; 
        font-size: 8px;
    }
    
    th, td { 
        border: 1px solid #ccc; 
        padding: 3px 4px; 
        text-align: left; 
        vertical-align: top;
        line-height: 1.1;
    }
    
    th { 
        background: #f0f0f0; 
        font-weight: bold; 
        font-size: 8px;
    }
    
    .grid { 
        display: grid; 
        grid-template-columns: repeat(3, 1fr); 
        gap: 4px; 
        margin-bottom: 5px;
    }
    
    .grid-2 { 
        display: grid; 
        grid-template-columns: repeat(2, 1fr); 
        gap: 4px; 
        margin-bottom: 5px;
    }
    
    .grid-4 { 
        display: grid; 
        grid-template-columns: repeat(4, 1fr); 
        gap: 4px; 
        margin-bottom: 5px;
    }
    
    .separator { 
        border-top: 1px solid #ddd; 
        margin: 6px 0; 
    }
    
    .compact { 
        margin-bottom: 1px; 
    }
    
    @page { 
        margin: 1cm; 
        size: A4;
    }
`;
